import React from "react";
import { Clock } from "lucide-react";
import { usePro } from "@/context/ProContext";

export const ProDeliveryDelay = ({ className = "", testid = "pro-delivery-delay" }) => {
  const { config } = usePro();
  if (!config?.delivery_delay) return null;
  return (
    <p data-testid={testid} className={`flex items-start gap-2 text-xs text-[var(--oz-text)] ${className}`}>
      <Clock className="w-4 h-4 shrink-0 text-[var(--oz-gold)]" />
      <span>{config.delivery_delay}</span>
    </p>
  );
};
